import { UntypedFormGroup } from '@angular/forms';
import { Directive, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

@Directive()
export abstract class AuthBaseDirective implements OnDestroy {
  error: string | null;
  formValueSubscription: Subscription;

  onChanges(form: UntypedFormGroup): void {
    this.formValueSubscription = form.valueChanges.subscribe((val) => {
      this.error = null;
    });
  }

  ngOnDestroy(): void {
    this.formValueSubscription?.unsubscribe();
  }
}
